import appsettings from '@/appsettings'
import { buildAxiosClient } from '@xbus/axios'
buildAxiosClient({ baseUrl: appsettings.apiUrl })